import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import translations from '../../i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {rosterErrors, sdoNs} from '@modules/constants-enumerate';

/**
 * @summary InvalidHeaderErrors
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('invalid-header-errors')
class InvalidHeaderErrors extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of InvalidHeaderErrors.
   */
  constructor() {
    super();

    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'invalid-header-errors';
  @property({type: Boolean})
  show = false;
  @property({type: Array})
  errors = [];
  @property({type: Object})
  roster = {};
  @property({type: Boolean})
  useActiveRoster = false;

  mapStateProperties() {
    if (this.useActiveRoster) {
      const state = this.storeInstance.getState();

      this.show = state[sdoNs.USER_JOBS].$rosterInvalidHeaderPropertyError;
      if (this.show) {
        this.errors = state[sdoNs.USER_JOBS].$activeRosterJob.errors;
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.roster?.id) {
      this.useActiveRoster = false;
      this.show = this.hasInvalidHeaderPropertyError();
      if (this.show) {
        this.errors = this.roster.errors;
      }
    }
    else {
      this.useActiveRoster = true;
    }
  }

  hasInvalidHeaderPropertyError() {
    if (Array.isArray(this.roster?.errors) &&
    this.roster.errors.length > 0) {
      return this.roster.errors.some((item) => {
        return item.type === rosterErrors.CSV_INVALID_PROPERTY || item.type === rosterErrors.INVALID_TIERS;
      });
    }
    return false;
  }

  /**
   *
   * @param {Number|String} num
   */
  numberToExcelCol(num) {
    let mod = null;
    let column = '';
    while (num > 0) {
      mod = (num - 1) % 26;
      column = String.fromCharCode(65 + mod) + column;
      num = Math.floor((num - mod) / 26);
    }
    return column;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    if (this.show) {
      return super.render({
        default: {template, styles: [styles]}
      });
    }
    return super.render({
      default: {template: () => '', styles: [':host {display: none;}']}
    });
  }
}

export default InvalidHeaderErrors;
